import html2canvas from "html2canvas";
import {
  waitForRender,
  captureElementAsImage,
  getShipmentAlarmSections,
} from "../pdfUtils";
import { drawTelemetryTable } from "../helpers/drawTelemetryTable";
import { drawAlarmSummary } from "../helpers/drawAlarmSummary";
import { drawShipmentSections } from "../helpers/drawShipmentSections";
import { drawLogisticsEventsTable } from "../helpers/drawLogisticsEventsTable";

export async function generateDetailedReportPages({
  pdf,
  chartRef,
  stepsRef,
  reportData,
  telemetryInfo,
  alerts,
  margin,
  pageWidth,
  pageHeight,
  maxWidth,
  onBeforeCapture,
  isStandalone,
}) {
  // Página 1 - Temperatura
  pdf.addPage();
  pdf.setFillColor(180, 180, 180);
  pdf.rect(margin, margin, pageWidth - margin * 2, 16, "F");
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text("Gráfica de temperatura", margin + 5, margin + 12);

  await onBeforeCapture("temperature");
  try {
    await waitForRender();
  } catch (error) {
    console.error("Error en waitForRender para temperatura:", error);
  }

  const yTempImg = margin + 30;
  const tempImage = await captureElementAsImage(
    chartRef,
    maxWidth,
    pageHeight - yTempImg - 150
  );

  pdf.addImage(
    tempImage.imgData,
    "JPEG",
    margin,
    yTempImg,
    tempImage.imgWidth,
    tempImage.imgHeight
  );

  const yTableStart = yTempImg + tempImage.imgHeight + 20;
  pdf.setFillColor(180, 180, 180);
  pdf.rect(margin, yTableStart, pageWidth - margin * 2, 16, "F");
  pdf.text("Mediciones Temperatura", margin + 5, yTableStart + 12);

  drawTelemetryTable({
    pdf,
    data: telemetryInfo,
    startY: yTableStart + 26,
    type: "temp",
    pageHeight,
    margin,
  });

  // Página 2 - Humedad
  if (!isStandalone) {
    pdf.addPage();
    pdf.setFillColor(180, 180, 180);
    pdf.setFont("helvetica", "bold");
    pdf.rect(margin, margin, pageWidth - margin * 2, 16, "F");
    pdf.text("Gráfica de humedad", margin + 5, margin + 12);

    await onBeforeCapture("humidity");
    try {
      await waitForRender();
    } catch (error) {
      console.error("Error en waitForRender para humedad:", error);
    }

    const yHumImg = margin + 30;
    const humImage = await captureElementAsImage(
      chartRef,
      maxWidth,
      pageHeight - yHumImg - 150
    );

    pdf.addImage(
      humImage.imgData,
      "JPEG",
      margin,
      yHumImg,
      humImage.imgWidth,
      humImage.imgHeight
    );

    const yHumTableStart = yHumImg + humImage.imgHeight + 20;
    pdf.setFillColor(180, 180, 180);
    pdf.rect(margin, yHumTableStart, pageWidth - margin * 2, 16, "F");
    pdf.text("Mediciones Humedad", margin + 5, yHumTableStart + 12);

    drawTelemetryTable({
      pdf,
      data: telemetryInfo,
      startY: yHumTableStart + 26,
      type: "humidity",
      pageHeight,
      margin,
    });

    // Página 3 - Alarmas + gráfica resumen
    pdf.addPage();

    const alarmSections = await getShipmentAlarmSections(reportData);

    let yAlarm = drawShipmentSections(pdf, margin, alarmSections);
    yAlarm = drawAlarmSummary(pdf, alerts, yAlarm);

    await onBeforeCapture("full");
    try {
      await waitForRender();
    } catch (error) {
      console.error("Error en waitForRender para gráfica completa:", error);
    }

    const yFullImg = yAlarm + 10;
    const fullImage = await captureElementAsImage(
      chartRef,
      maxWidth,
      pageHeight - yFullImg - margin
    );

    pdf.addImage(
      fullImage.imgData,
      "JPEG",
      margin,
      yFullImg,
      fullImage.imgWidth,
      fullImage.imgHeight
    );
  }

  // Página 4 - Trazabilidad logística
  pdf.addPage();
  pdf.setFillColor(180, 180, 180);
  pdf.setFont("helvetica", "bold");
  pdf.rect(margin, margin, pageWidth - margin * 2, 16, "F");
  pdf.text("Detalle Trazabilidad Logística", margin + 5, margin + 12);

  try {
    await waitForRender();
  } catch (error) {
    console.error("Error en waitForRender para eventos:", error);
  }

  let yAfterSteps = margin + 30;
  if (stepsRef?.current) {
    const canvasSteps = await html2canvas(stepsRef.current, {
      scale: 2,
      backgroundColor: "#ffffff",
    });

    const stepsImg = canvasSteps.toDataURL("image/jpeg", 1.0);
    let stepsWidth = maxWidth;
    let stepsHeight = (canvasSteps.height * stepsWidth) / canvasSteps.width;
    let yStepsImg = margin + 30;

    if (stepsHeight > pageHeight - yStepsImg - margin) {
      stepsHeight = pageHeight - yStepsImg - margin;
      stepsWidth = (canvasSteps.width * stepsHeight) / canvasSteps.height;
    }

    pdf.addImage(stepsImg, "JPEG", margin, yStepsImg, stepsWidth, stepsHeight);
    yAfterSteps = yStepsImg + stepsHeight + 20;
  }

  drawLogisticsEventsTable(
    pdf,
    reportData.totalLogisticsTraceability,
    yAfterSteps,
    margin
  );
}
